import React, { useEffect, useState } from 'react';
import { Container, Box, Button } from '@mui/material';
import axios from 'axios';
import MenuAppBar from '../components/MenuAppBar';

const Param = () => {
  const [params, setParams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const getAuthHeaders = () => {
    const token = localStorage.getItem("accessToken");
    return { Authorization: `Bearer ${token}` };
  };

  const loadData = async () => {
    
      const response = await axios.get('/api/params/', { headers: getAuthHeaders() });
      setParams(response.data);
    
      setLoading(false);
    
  };
  useEffect(() => {
    loadData();
  }, []);

  const [editedParams, setEditedParams] = useState({});
  if (loading) return <div>Loading...</div>;

  

  const handleAddNewRecord = () => {
    const newId = params.length > 0 ? Math.max(...params.map(p => p.idparam)) + 1 : 1;
    const newRecord = { idparam: null, paramkey: '', parampopis: '', paramvalue: '' };
    setParams((prev) => [...prev, newRecord]);
    setEditedParams((prev) => ({
      ...prev,
      [newId]: newRecord,
    }));
  };
  if (error) return <div>{error}</div>;

  const handleInputChange = (idparam, field, value) => {
    
    setEditedParams((prev) => ({
      ...prev,
      [idparam]: {
        ...prev[idparam],
        [field]: value,
      },
    }));
  };

  const handleSave = async (idparam) => {
    if (!editedParams[idparam]) return;
    //const idparam = editedParams[idparam].idparam;
    const updatedParam = params.find((param, index) => {
      if (param.idparam === idparam) {
        return param;
      }
    });
    const send = {...updatedParam, ...editedParams[idparam]};
    try {
      await axios.post('/api/params/', {
        idparam,
        //...editedParams[idparam],
        ...send,
      }, { headers: getAuthHeaders() });
      alert('Parameter saved successfully.');
    } catch (err) {
      alert('Failed to save parameter.');
    }
  };

  return (
    <Container>
    <MenuAppBar title='Parametry' />
    <Box mb={2}>
      <Button variant="contained" color="primary" onClick={handleAddNewRecord}>
        Nový záznam
      </Button>
    </Box>
    <div>
      <h1>Parameters</h1>
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Key</th>
            <th>Description</th>
            <th>Value</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {params.map((param) => (
            <tr key={param.idparam}>
              <td>{param.idparam}</td>
              <td>
                <input
                  type="text"
                  value={editedParams[param.idparam]?.paramkey || param.paramkey}
                  onChange={(e) =>
                    handleInputChange(param.idparam, 'paramkey', e.target.value)
                  }
                />
              </td>
              <td>
                <input
                  type="text"
                  value={editedParams[param.idparam]?.parampopis || param.parampopis}
                  onChange={(e) =>
                    handleInputChange(param.idparam, 'parampopis', e.target.value)
                  }
                />
              </td>
              <td>
                <input
                  type="text"
                  value={editedParams[param.idparam]?.paramvalue || param.paramvalue}
                  onChange={(e) =>
                    handleInputChange(param.idparam, 'paramvalue', e.target.value)
                  }
                />
              </td>
              <td>
                <button onClick={() => handleSave(param.idparam)}>Save</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    </Container>
  );
};

export default Param;